import { getWindowSafe } from '@change-corgi/core/window';

/**
 * Get the image size adjusted for device's pixel ratio.  In non-window environments
 * a device pixel ratio of 1 is assumed.  The device pixel ratio is not allowed to be
 * less than 1 because the intent is to increase fidelity, not decrease it.
 *
 * @param size - The size of the image in pixels
 * @returns The device adjusted image size in pixels
 */
export function getDeviceAdjustedImageSize(size: number): number {
	const devicePixelRatio = Math.max(1, getWindowSafe()?.devicePixelRatio || 1);
	return Math.round(size * devicePixelRatio);
}
